import followersMutations from "./followers/mutations"
import followingMutations from "./following/mutations"
import {
    SET_CURRENT_PROFILE,
    SET_PROFILE_LOADING,
    CLEAR_CURRENT_PROFILE,
    CLEAR_PROFILE_POST_LIST,
    SET_PROFILE_POST_LIST_LOADING,
    SET_PROFILE_SAVED_POST_LIST_LOADING,
    SET_PROFILE_TAGGED_POST_LIST_LOADING,
    PUSH_PROFILE_POST,
    PUSH_SAVED_PROFILE_POST,
    PUSH_TAGGED_PROFILE_POST,
    UPDATE_ACTIVE_PROFILE
} from '@/store/mutations.type'

export default {
    [SET_CURRENT_PROFILE](state, payload) {
        state.activeProfile = payload
        state.profileErrors = {}
    },

    [CLEAR_CURRENT_PROFILE](state) {
        state.activeProfile = {}
        state.activeProfileLoading = false
        state.profileErrors = {}
    },

    [CLEAR_PROFILE_POST_LIST](state) {
        state.profilePostList = []
        state.profileSavedPostList = []
        state.profileTaggedPostList = []
        state.profilePostFetchCompleted = false
        state.profileSavedPostFetchCompleted = false
        state.profileTaggedPostFetchCompleted = false
        state.profilePostListOffset = 0
        state.profileSavedPostListOffset = 0
        state.profileTaggedPostListOffset = 0
    },

    [SET_PROFILE_LOADING](state, flag) {
        state.activeProfileLoading = flag
    },

    [SET_PROFILE_POST_LIST_LOADING](state, flag) {
        state.profilePostListLoading = flag
    },

    [SET_PROFILE_SAVED_POST_LIST_LOADING](state, flag) {
        state.profileSavedPostListLoading = flag
    },

    [SET_PROFILE_TAGGED_POST_LIST_LOADING](state, flag) {
        state.profileTaggedPostListLoading = flag
    },

    [PUSH_PROFILE_POST](state, posts) {
        if (posts.length) {
            posts.forEach((post) => {
                if (post) state.profilePostList.push(post)
            })
        }

        if (posts.length === state.profilePostListLimit) {
            state.profilePostListOffset += state.profilePostListLimit
        } else {
            state.profilePostFetchCompleted = true
        }
    },

    [PUSH_SAVED_PROFILE_POST](state, posts) {
        if (posts.length) {
            posts.forEach((post) => {
                if (post) state.profileSavedPostList.push(post)
            })
        }

        if (posts.length === state.profilePostListLimit) {
            state.profileSavedPostListOffset += state.profilePostListLimit
        } else {
            state.profileSavedPostFetchCompleted = true
        }
    },

    [PUSH_TAGGED_PROFILE_POST](state, posts) {
        if (posts.length) {
            posts.forEach((post) => {
                if (post) state.profileTaggedPostList.push(post)
            })
        }

        if (posts.length === state.profilePostListLimit) {
            state.profileTaggedPostListOffset += state.profilePostListLimit
        } else {
            state.profileTaggedPostFetchCompleted = true
        }
    },

    [UPDATE_ACTIVE_PROFILE](state, payload) {
        Object.assign(state.activeProfile, payload)
    },

    ...followersMutations,
    ...followingMutations
}